export default __webpack_public_path__ + "static/media/add.c9b21985.svg";